export enum ReferenceTypes {
	Employment = 1,
	Character = 2,
	Education = 3,
	Factual = 4,
	Academic = 5,
	Volunteer = 6,
}
